// Regions an Intercom workspace can be hosted in; each has its own API host
export const intercomRegions = [
  { value: 'us', label: 'US' },
  { value: 'eu', label: 'EU' },
  { value: 'au', label: 'Australia' },
];
